<form (ngSubmit)="postJobDescription()" [formGroup]="jobDescriptionForm">
  <div class="main-body">
    <div class="row col-md-12 mb-3" *ngIf="!isSimplify">
      <h5 class="sub-title">Identify Work Location</h5>
    </div>
    <div class="row col-md-12 mb-3">
      <div class="col-3 pl-0">
        <p-radioButton name="workLocationTypeCode" (onClick)="handleWorkLocationChange()" [disabled]="disabledControls"
          styleClass="radio-style" class="p-col" formControlName="workLocationTypeCode" value="INHSE" label="In-House">
        </p-radioButton>
      </div>
      <div class="col-3 pl-0" *ngIf="inputData.visatype !== 'L1A'">
        <p-radioButton (onClick)="handleWorkLocationChange()" [disabled]="disabledControls" name="workLocationTypeCode"
          formControlName="workLocationTypeCode" value="TPARTY" label="Third Party Site">
        </p-radioButton>
      </div>
      <div class="col-6 pl-0" *ngIf="inputData.visatype === 'H1-B' || inputData.layoutCode === 'H1_B_POSITION_DETAIL' ">
        <p-radioButton (onClick)="handleWorkLocationChange()" [disabled]="disabledControls" name="workLocationTypeCode"
          formControlName="workLocationTypeCode" value="INHSECLT" label="Third Party Project Developed In-House">
        </p-radioButton>
      </div>
    </div>
    <div class="row col-md-12 pl-0" *ngIf="jobDescriptionForm.get('workLocationTypeCode').value !== null">
      <div class="row w-100 mb-3"
        *ngIf="inputData.visatype !== 'L1A' && (jobDescriptionForm.get('workLocationTypeCode').value === 'TPARTY' || jobDescriptionForm.get('workLocationTypeCode').value === 'INHSECLT')">
        <div class="col-md-6 form-group input-disabled">
          <label class="label-cls required"> Client Name </label>
          <input class="im-input mw-100" id="clientName" formControlName="clientName" type="text" pInputText
            [readonly]="disabledControls" placeholder="Enter" />
          <div
            *ngIf="jobDescriptionForm.controls['clientName'].touched && jobDescriptionForm.controls['clientName'].invalid">
            <span class="invalid-message" *ngIf="jobDescriptionForm.controls['clientName'].errors?.clientNameIsRequired">
              {{getGlobalErrorMessages('REQUIRED')}}
            </span>
          </div>
        </div>
      </div>
      <div class="row col-md-12 pl-0 ml-0" *ngIf="jobDescriptionForm.get('workLocationTypeCode').value != null">
        <div class="row col-md-12 pl-0 mb-3"
          *ngIf="inputData.visatype !== 'L1A' && (jobDescriptionForm.get('workLocationTypeCode').value === 'TPARTY' || jobDescriptionForm.get('workLocationTypeCode').value === 'INHSECLT')">
          <div class="col-md-6 input-disabled">
            <label class="label-cls"> Phone Number </label>
            <div class="row">
              <div *ngIf="isForeignCompany" class="col-md-4 pl-0 pr-0 processing-dropdown">
                <p-dropdown [options]="countryList" [filter]="false" formControlName="clientPhoneCode"
                  optionLabel="phoneCode" optionValue="countryCode" placeholder="Select CountryCode"
                  [disabled]="disabledControls">
                  <ng-template let-item pTemplate="item">
                    <div class="p-d-flex p-ai-center">
                      <span> (+{{item.phoneCode}}) - {{ item.countryName }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="col-md-8 px-0 input-disabled">
                <input class="im-input mw-100" type="text" placeholder="Phone Number" formControlName="clientPhoneNo"
                  pInputText maxlength="10" pattern="\d{1,10}" [readonly]="disabledControls" />
              </div>
            </div>
          </div>
          <div class="col-md-6 input-disabled">
            <label class="label-cls"> Email ID </label>
            <input class="im-input mw-100" id="clientEmail" formControlName="clientEmail" pInputText type="email"
              [readonly]="disabledControls" placeholder="Enter" />
          </div>
        </div>
        <div class="row mb-3" formArrayName="address">
          <div class="row" *ngFor="let item of getAddressFormArray(); let addressIndex= index">
            <div class="row w-100" [formGroupName]="addressIndex">
              <div class="col-md-12 d-flex justify-content-end">
                <button pButton pRipple type="button" [disabled]="disabledControls" title="Delete"
                  *ngIf="addressIndex !='0'" (click)="handleDeleteWorkLocation(item, addressIndex)" icon="pi pi-trash"
                  pTooltip="Delete" class="pull-right p-button-rounded p-button-text"></button>
              </div>
              <div class="row w-100 mb-0">
                <div class="col-md-6 form-group input-disabled">
                  <label class="label-cls required"> Address 1 </label>
                  <input class="im-input mw-100" id="addressLine1" formControlName="addressLine1" type="text" pInputText
                    [readonly]="disabledControls" placeholder="Enter" />
                  <div *ngIf="item.get('addressLine1').touched && item.get('addressLine1').invalid">
                    <span class="invalid-message" *ngIf="item.get('addressLine1').errors?.required">
                      {{getGlobalErrorMessages('REQUIRED')}}
                    </span>
                  </div>
                </div>
                <div class="col-md-6 input-disabled">
                  <label class="label-cls"> Address 2 </label>
                  <input class="im-input mw-100" id="addressLine2" formControlName="addressLine2" pInputText type="text"
                    [readonly]="disabledControls" placeholder="Enter" />
                  <div *ngIf="item.get('addressLine2').touched && item.get('addressLine2').invalid">
                    <span class="invalid-message" *ngIf="item.get('addressLine2').errors?.required">
                      {{getGlobalErrorMessages('REQUIRED')}}
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="isForeignCompany" class="col-md-3 form-group processing-dropdown">
                <label class="label-cls  required"> Country </label>
                <p-dropdown appendTo="body" [options]="countryList" id="countryCode" formControlName="countryCode"
                  [disabled]="disabledControls" name="country" optionLabel="countryName" optionValue="countryCode"
                  placeholder="select" (onChange)="handleCountryChange($event.value, item, true)"> </p-dropdown>
                <div *ngIf="item.controls['countryCode'].touched && item.controls['countryCode'].invalid">
                  <span class="invalid-message" *ngIf="item.controls['countryCode'].errors?.required">
                    {{getGlobalErrorMessages('REQUIRED')}}
                  </span>
                </div>
              </div>
              <div class="col-md-3 form-group processing-dropdown"
                *ngIf="item.get('stateList').value && item.get('stateList').value.length>0">
                <label class="label-cls  required"> State </label>
                <p-dropdown appendTo="body" [options]="item.get('stateList').value" id="stateProvinceCode"
                  formControlName="stateProvinceCode" [disabled]="disabledControls" name="country"
                  optionLabel="stateProvinceName" optionValue="stateProvinceCode" placeholder="select"> </p-dropdown>
                <div *ngIf="item.controls['stateProvinceCode'].touched && item.controls['stateProvinceCode'].invalid">
                  <span class="invalid-message" *ngIf="item.controls['stateProvinceCode'].errors?.required">
                    {{getGlobalErrorMessages('REQUIRED')}}
                  </span>
                </div>
              </div>
              <div class="col-md-3 input-disabled"
                *ngIf="item.get('stateList').value && item.get('stateList').value.length <= 0">
                <label class="label-cls"> State </label>
                <input class="im-input mw-100" id="stateProvinceName" formControlName="stateProvinceName" type="text"
                  [readonly]="disabledControls" pInputText placeholder="Enter" />
                <div *ngIf="item.controls['stateProvinceName'].touched && item.controls['stateProvinceName'].invalid">
                  <span class="invalid-message" *ngIf="item.controls['stateProvinceName'].errors?.required">
                    {{getGlobalErrorMessages('REQUIRED')}}
                  </span>
                </div>
              </div>
              <div class="col-md-3 input-disabled">
                <label class="label-cls  required"> City </label>
                <input class="im-input mw-100" id="city" formControlName="city" pInputText type="text"
                  [readonly]="disabledControls" placeholder="Enter" />
                <div *ngIf="item.get('city').touched && item.get('city').invalid">
                  <span class="invalid-message" *ngIf="item.get('city').errors?.required">
                    {{getGlobalErrorMessages('REQUIRED')}}
                  </span>
                  <span class="invalid-message" *ngIf="item.get('city').errors?.pattern">
                    {{getGlobalErrorMessages('INVALID_FORMAT')}}
                  </span>
                </div>
              </div>
              <div class="col-md-3 input-disabled">
                <label class="label-cls required"> Postal Code </label>
                <input class="im-input mw-100" id="postCode" formControlName="postCode" type="text" pInputText
                  [readonly]="disabledControls" placeholder="Enter" />
                <div *ngIf="item.get('postCode').touched && item.get('postCode').invalid">
                  <span class="invalid-message" *ngIf="item.get('postCode').errors?.required">
                    {{getGlobalErrorMessages('REQUIRED')}}
                  </span>
                </div>
              </div>
              <p-divider class="mb-3 w-100" *ngIf="addressIndex < (getAddressFormArray().length - 1)">
              </p-divider>
            </div>
          </div>
        </div>
        <p-divider class="row w-100"></p-divider>
        <div class="row col-md-12 save-location">
          <div class="row col-md-12 pl-0 save-location">
            <button type="button" [disabled]="disabledControls" pButton class="mt-1 p-button-outlined"
              (click)="handleAddLocationClick()">Add Locations</button>
          </div>
        </div>
      </div>

      <div class="row col-md-12 pl-0 pb-2" *ngIf="jobDescriptionForm.get('workLocationTypeCode').value === 'TPARTY'">
        <p-divider class="row col-md-12 pl-0 pr-0 pb-2"></p-divider>
        <div class="row col-md-12 pb-2">
          <p-checkbox label="Is there a middle vendor" value="isMiddleVendor" formControlName="isMiddleVendor"
            binary="true" (onChange)="handleVendorChkboxChange($event)"></p-checkbox>
        </div>
        <div class="row mb-3" formArrayName="vendorList">
          <div class="row col-md-12  mt-4" *ngIf="jobDescriptionForm.get('isMiddleVendor').value">
            <div class="col-md-4 pl-0">
              <label><b>Vendor Details</b></label>
            </div>
            <div class="col-md">
              <label><b>Vendor Point of Contact</b></label>
            </div>
          </div>
          <div class="row col-md-12" *ngFor="let item of getVendorListFormArray(); let vendorIndex= index">
            <div class="row col-md-12 p-0" [formGroupName]="vendorIndex">
              <div class="col-md-3 pl-0">
                <label class="label-cls">Name</label>
                <input class="im-input mw-100" [readonly]="disabledControls" formControlName="vendorName" type="text"
                  pInputText placeholder="Enter" />
              </div>
              <div class="col-md-3">
                <label class="label-cls">First Name</label>
                <input class="im-input mw-100" [readonly]="disabledControls" formControlName="vendorLastName"
                  type="text" pInputText placeholder="Enter" />
              </div>
              <div class="col-md-3">
                <label class="label-cls">Last Name</label>
                <input class="im-input mw-100" [readonly]="disabledControls" formControlName="vendorFirstName"
                  type="text" pInputText placeholder="Enter" />
              </div>
              <div class="col-md-3 mt-4">
                <label class="label-cls"></label>
                <button pButton type="button" [disabled]="disabledControls" (click)="addVendor()" icon="pi pi-plus"
                  title="Add Vendor" pTooltip="Add Vendor" class="p-button-raised p-button-rounded"
                  style="margin-right: 20px;"></button>
                <button pButton type="button" [disabled]="disabledControls" title="Delete"
                  *ngIf="jobDescriptionForm.get('vendorList').value.length > 1" (click)="deleteVendor(vendorIndex)"
                  icon="pi pi-trash" pTooltip="Delete" class="p-button-raised p-button-rounded"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-9"></div>
  <div class="col-md-3 alignRight">
    <button pButton type="submit" label="{{isFromWizard ? 'Save' : 'Save & Continue'}}" title="Save"
      [ngClass]="jobDescriptionForm.invalid  || disabledControls  ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
      [disabled]="jobDescriptionForm.invalid  || disabledControls "></button>
  </div>
  </div>
</form>  